export default "__VITE_ASSET__c6500ad0__"